import { useTranslation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import sanitizeHtml from 'sanitize-html';

import { SavingStatus } from '../../types';

interface Props {
    isOpen: boolean;
    savingStatus: SavingStatus;
    retrySave: () => void;
}

const SavingDialog = (props: Props) => {
    const { isOpen, savingStatus, retrySave } = props;

    const { t } = useTranslation();

    return (
        <>
            <CustomDialog open={isOpen} maxWidth='sm' >
                <DialogTitle>
                    {t('dialogs.kpi_saving.' + (savingStatus === 'failed' ? 'error' : 'saving') + '_title')}
                </DialogTitle>

                <DialogContent dividers >
                    <Typography variant='body1'>
                        <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(t('dialogs.kpi_saving.' + (savingStatus === 'failed' ? 'error' : 'saving') + '_message')) }} />
                    </Typography>

                    {savingStatus !== 'failed' && <LinearProgress style={{ margin: '18px 0' }} />}
                </DialogContent>

                {savingStatus === 'failed' && (
                    <DialogActions>
                        <Button color='primary' onClick={retrySave}>{t('dialogs.kpi_saving.retry_button')}</Button>
                    </DialogActions>
                )}
            </CustomDialog>
        </>
    );
};

export default SavingDialog;
